export enum AttendanceStatus {
    UNMARKED = 0,
    EXCUSED = 1,
    NOT_ATTENDED = 2,
    ATTENDED = 3,
}
